<template>
	<v-container fluid class="blue-grey lighten-5">
		<v-container grid-list-lg>
			<v-row>
				<v-col>
					<h1 class="font-weight-black black--text text-xs-center my-1">ماژول های پازار نسخه پلاس</h1>
				</v-col>
				<!-- <v-divider></v-divider> -->
			</v-row>

			<v-row justify-right row wrap class="moduls-cards">
				<v-col xs="12" sm="6" md="4" v-for="(item, idx) in plusModules" :key="idx">
					<v-hover>
						<v-card :to="item.link" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
							<v-responsive>
								<v-img :src="item.image" height="300px">
									<!-- <br />
									<v-container fill-height fluid>
										<v-layout fill-height>
											<v-flex xs12 align-end flexbox></v-flex>
										</v-layout>
									</v-container> -->
								</v-img>
							</v-responsive>
							<v-card-text>
								<div>
									<h2 class="font-weight-black black--text text-xs-right mb-1">{{ item.text }}</h2>
								</div>
								<v-divider></v-divider>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<h4 class="font-weight-thin black--text text-xs-right mb-0">{{ item.price }}</h4>
							</v-card-actions>
						</v-card>
					</v-hover>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>

<script>
export default {
	name: "PlusModulesCards",
	computed: {
		plusModules() {
			return this.$store.state.plusModules;
		},
	},
};
</script>
